import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import SideMenu from "../General/SideMenu";
import $ from "jquery";
import { Ask_Question, Show_Message } from "../General/Messagedialogbox";
import { useDispatch, useSelector } from "react-redux";
import PartyCreation from "../Transaction/PartyCreation";
import CustomizedSelectoption from "../General/CustomizedSelectoption";
import CustomTransView from "../Transaction/CustomTransView";
import Messagedialogbox from "../General/Messagedialogbox";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
import ReactTable from "../General/ReactTable";

//#region Helpers (outside component - no re-creation on every render)
const ZERO_SUMMARY = {
  netAmt: 0,
  totalDiscount: 0,
  goodsValue: 0,
  totalTax: 0,
  roundOff: 0,
};

// FIX: toISOString() is UTC -> between 12:00 AM and 5:30 AM IST it gave YESTERDAY's date
const todayLocal = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Date input needs yyyy-MM-dd. Accept dd-MM-yyyy / dd/MM/yyyy coming from server too.
const toInputDate = (s, fallback = todayLocal()) => {
  if (!s) return fallback;
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.substring(0, 10);
  const m = String(s).match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : s;
};

// Null / "" / undefined safe number formatting (table cells crashed on "" and null before)
const fmtNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
};
// en-IN => lakh/crore grouping like Zoho India (1,00,000.00)
const fmtINR = (v) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(
    Number(v) || 0
  );
// DISPLAY only (lakh grouping 1,00,000.00). Never put this into an <input> value.
const fmtView = (v) => {
  const n = Number(v);
  return (Number.isFinite(n) ? n : 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
const numCell = (props) => fmtView(props.value);

// Only digits + one dot + max 2 decimals, no useless leading zeros ("05" -> "5", "00.5" -> "0.5")
const cleanDecimal = (txt) => {
  let t = String(txt).replace(/[^0-9.]/g, "");
  const parts = t.split(".");
  if (parts.length > 2) t = parts[0] + "." + parts.slice(1).join("");
  let [i, d] = t.split(".");
  i = i.replace(/^0+(?=\d)/, "");
  return d === undefined ? i : i + "." + d.slice(0, 2);
};

// Find the next ENABLED + visible tab stop (disabled inputs / buttons used to trap the Enter key)
const focusTab = (from, step, maxTab) => {
  let idx = from;
  for (let n = 0; n <= maxTab + 1; n++) {
    idx += step;
    if (idx > maxTab) idx = 0;
    if (idx < 0) idx = maxTab;
    const $el = $("[tabindex='" + idx + "']").filter(function () {
      return !this.disabled && $(this).is(":visible");
    });
    if ($el.length > 0) {
      $el.first().focus();
      if ($el.first().is("input,textarea")) $el.first().select();
      return true;
    }
  }
  return false;
};

// Dropdown component calls .toLowerCase() on displayName -> guarantee it is always a string,
// and tolerate camelCase / PascalCase differences in the API json.
const normalizeList = (list, displayKey, valueKey) =>
  (Array.isArray(list) ? list : []).map((item) => {
    const out = { ...item };
    [displayKey, valueKey].forEach((target) => {
      if (out[target] === undefined) {
        const found = Object.keys(item).find(
          (k) => k.toLowerCase() === target.toLowerCase()
        );
        if (found !== undefined) out[target] = item[found];
      }
    });
    out[displayKey] = String(out[displayKey] ?? "");
    return out;
  });

// Party search answers differ per screen (EntParty / entParty, partyId / PartyId / iPartyId ...).
// Always hand the UI { partyId, partyName } so a casing difference can never break vendor selection.
const pick = (o, names) => {
  const keys = Object.keys(o || {});
  for (const n of names) {
    const k = keys.find((x) => x.toLowerCase() === n.toLowerCase());
    if (k !== undefined && o[k] !== null && o[k] !== undefined) return o[k];
  }
  return undefined;
};
const normalizeParties = (res) => {
  if (!res) return [];
  let list = pick(res, ["EntParty", "objParty", "partyList", "data"]);
  if (!Array.isArray(list))
    list = Object.values(res).find((v) => Array.isArray(v)) || [];
  return list
    .map((p) => ({
      ...p,
      partyId: pick(p, ["partyId", "iPartyId", "id", "suppId", "ledgerId"]),
      partyName: String(
        pick(p, ["partyName", "strPartyName", "suppName", "name", "ledgerName"]) ?? ""
      ),
    }))
    .filter((p) => p.partyId !== undefined);
};

// ctrl name in Transtab (DB)  ->  key in ListTabOrder
const TAB_KEYS = {
  txtPartyName: "txtPartyName",
  txtBillAddress: "txtBillAddress",
  txtBillDiscValue: "txtBillDiscValue",
  cbBillType: "cbBillType",
  cbTaxType: "cbTaxType",
  txtTransNo: "txtTransNo",
  txtEINo: "txtEINo",
  dpEIDate: "dpEIDate",
  txtBillDiscPer: "txtBillDiscPer",
  txtBillDiscAmt: "txtBillDiscAmt",
  btnNew: "btnNew",
  btnModify: "btnModify",
  btnSave: "btnSave",
  btnClear: "btnClear",
  btnView: "btnView",
  btnExportImport: "btnExportImport",
  btnPrint: "btnPrint",
  btnCancel: "btnCancel",
  btnClose: "btnClose",
  btnPrintSettings: "btnPrintSettings",
  btnHelp: "btnHelp",
  txtRemark1: "txtRemark1",
  txtRemark2: "txtRemark2",
  txtRemark3: "txtRemark3",
  txtRemark4: "txtRemark4",
  btnRefresh: "btnRefresh",
  TopLeftParty: "TabParty",
  TopCenterVoucher: "TabVoucher",
  TopRightRemarks: "TabRemarks",
  MiddleRightSummary: "TabSummary",
  MiddleRightTax: "TabTax",
  MiddleRightDiscount: "TabDiscount",
  // These were never mapped before => Service Name / Rate / Discount / Add had NO tab index.
  // NOTE: confirm these ctrl names exist in the Transtab setup of ScrId 66.
  txtServiceName: "txtServiceName",
  txtRate: "txtRate",
  txtDiscount: "txtDiscount",
  btnAdd: "btnAdd",
  ServiceListTab: "ServiceListTab",
  ProductTableListTab: "ProductTableListTab",
};
//#endregion

// Service picker for this screen. Same pattern as the Party Master popup of Sales Invoice
// (title, search + green search button + column filter, grey header table, green active row, footer button).
// The shared ServiceSearch never returned the chosen row (click / Enter / double-click only called Close()).
// Uses the Service master search (same API the Service Master screen uses): rows carry iSerId + strSerName.
function ServicePicker({ onClose, onSelect }) {
  const dispatch = useDispatch();
  const _Auth = useSelector((state) => state.Common.Admin);
  const _DF = useSelector((state) => state.Transstates.Default);
  const [arr, setArr] = useState([]);
  const [txt, setTxt] = useState("");
  const [col, setCol] = useState("Name"); // filter column (like the Party Master popup)
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isNew, setIsNew] = useState(false);
  const seq = useRef(0);
  const listRef = useRef(null);

  // server search is always "All"; the Name filter narrows the rows locally
  const shown =
    col === "Name" && txt.trim() !== ""
      ? arr.filter((r) => r.serName.toLowerCase().includes(txt.trim().toLowerCase()))
      : arr;

  const load = async (t) => {
    setTxt(t);
    const my = ++seq.current;
    setLoading(true);
    try {
      const res = await API_POST(
        "ServiceMaster/Search_Service/",
        {
          iScrId: 59,
          iBranchId: Number(_Auth.Branch),
          iPartyId: 0,
          strColName: "All",
          strSearch: t,
          strDBName: _Auth.DB,
        },
        dispatch
      );
      if (my !== seq.current) return; // older answer, ignore
      const list = (res && (res.EntService || res.entService)) || [];
      setArr(
        list
          .map((r) => ({
            serId: Number(pick(r, ["iSerId", "serId", "id"])) || 0,
            serName: String(pick(r, ["strSerName", "serName", "strName", "name"]) ?? ""),
          }))
          .filter((r) => r.serId > 0)
      );
      setActive(0);
    } finally {
      if (my === seq.current) setLoading(false);
    }
  };

  useEffect(() => {
    load("");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const el = listRef.current && listRef.current.querySelectorAll("tbody tr")[active];
    if (el && el.scrollIntoView) el.scrollIntoView({ block: "nearest" });
  }, [active]);

  const pickRow = (r) => r && onSelect({ serId: r.serId, serName: r.serName });

  const th = {
    padding: "6px 10px",
    border: "1px solid #e3e5e8",
    background: "#f3f3f5",
    color: "#212529",
    fontWeight: 600,
    textAlign: "center",
  };

  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>SERVICE MASTER</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={onClose} title="Close (Esc)">
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row pro-card">
            <div className="col-sm-12 col-md-12 mt-2">
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <div className="m-hsearch" style={{ flex: 1, minWidth: 0 }}>
                  <input
                    type="text"
                    autoComplete="off"
                    autoCorrect="off"
                    placeholder="Search Service"
                    aria-label="Search service"
                    value={txt}
                    autoFocus
                    onChange={(e) => load(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setActive((a) => Math.min(shown.length - 1, a + 1));
                      } else if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setActive((a) => Math.max(0, a - 1));
                      } else if (e.key === "Enter") {
                        e.preventDefault();
                        if (shown.length > 0) pickRow(shown[Math.min(active, shown.length - 1)]);
                      } else if (e.key === "Escape") onClose();
                    }}
                  />
                  <i className="fas fa-search" onClick={() => load(txt)}></i>
                </div>
                <select
                  aria-label="Search column"
                  value={col}
                  onChange={(e) => {
                    setCol(e.target.value);
                    setActive(0);
                  }}
                  style={{
                    width: 200,
                    height: 38,
                    padding: "0 10px",
                    borderRadius: 6,
                    border: "1px solid #dfe3e8",
                    background: "#eef0f2",
                    color: "#212529",
                  }}
                >
                  <option value="Name">Name</option>
                  <option value="All">All</option>
                </select>
              </div>
            </div>
            {/* full width table directly under the search row, like Party Master */}
            <div
              ref={listRef}
              style={{
                maxHeight: 340,
                overflowY: "auto",
                width: "calc(100% + 26px)",
                margin: "10px -13px 0 -13px",
              }}
            >
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ ...th, width: 56 }}>S.No</th>
                    <th style={th}>Service Name</th>
                  </tr>
                </thead>
                <tbody>
                  {shown.map((r, i) => {
                    const on = i === active;
                    const td = {
                      padding: "5px 10px",
                      border: "1px solid #e3e5e8",
                      background: on ? "#006400" : "#fff",
                      color: on ? "#fff" : "#000",
                      fontWeight: on ? 700 : 400,
                      fontSize: 13,
                      cursor: "pointer",
                    };
                    return (
                      <tr key={r.serId} onMouseEnter={() => setActive(i)} onClick={() => pickRow(r)}>
                        <td style={{ ...td, textAlign: "center" }}>{i + 1}</td>
                        <td style={td}>{r.serName}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {!loading && shown.length === 0 && (
                <div style={{ padding: 16, color: "#6b7280", textAlign: "center" }}>
                  No services found. Use "Create Service" to add one.
                </div>
              )}
              {loading && shown.length === 0 && (
                <div style={{ padding: 16, color: "#6b7280", textAlign: "center" }}>Loading...</div>
              )}
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button type="button" className="btn-fabgreen" onClick={() => setIsNew(true)}>
              Create Service &nbsp;
              <i className="fa-solid fa-circle-plus"></i>
            </button>
          </div>
        </div>
        {isNew && !(_DF && _DF.isJobWork) && (
          <PartyCreation
            Close={() => {
              setIsNew(false);
              load(txt); // show the service that was just created
            }}
            strScrType="Service"
          />
        )}
      </div>
    </div>
  );
}

function ExpenseIncome() {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Selectparem = useSelector((state) => state.SelectOption.parems);
  //#region  Parems
  const [iScrId, setiScrId] = useState(66);
  const [iPartyId, setiPartyId] = useState(0);
  const [iEIId, setiEIId] = useState(0);
  const [strPartyName, setstrPartyName] = useState("");
  const [strPartyAdd, setstrPartyAdd] = useState("");
  const [strVouchNo, setstrVouchNo] = useState("");
  const [strVouchDate, setstrVouchDate] = useState(todayLocal());
  const [strTransNo, setstrTransNo] = useState("");
  const [strRemark1, setstrRemark1] = useState("");
  const [strRemark2, setstrRemark2] = useState("");
  const [strRemark3, setstrRemark3] = useState("");
  const [strRemark4, setstrRemark4] = useState("");
  const [iEITypeId, setiEITypeId] = useState(1);
  const [iVenTypeId, setiVenTypeId] = useState(2);
  const [iTaxCalcOnId, setiTaxCalcOnId] = useState(0);
  const [iTaxRelId, setiTaxRelId] = useState(0);
  const [iBillTypeId, setiBillTypeId] = useState(0);

  const [iSerId, setiSerId] = useState(0);
  const [strSerName, setstrSerName] = useState("");
  const [dPriceRate, setdPriceRate] = useState("0");
  const [isDiscPer, setisDiscPer] = useState(true);
  const [dItemDisc, setdItemDisc] = useState(0);
  const [strNetAmt, setstrNetAmt] = useState(fmtINR(0));
  const [dBillDisPer, setdBillDisPer] = useState(0);
  const [dBillDisAmt, setdBillDisAmt] = useState(0);
  const [dBillDisValue, setdBillDisValue] = useState(0);
  const [iGoodsValue, setiGoodsValue] = useState(0);
  const [iTotalDisc, setiTotalDisc] = useState(0);
  const [iTotalTax, setiTotalTax] = useState(0);
  const [iRountoff, setiRountoff] = useState(0);
  const [iRowIndex, setiRowIndex] = useState(0);

  const [strSetCurrentStatus] = useState("");
  const [bUpdateStatus, setbUpdateStatus] = useState(false);
  const [isNewParty, setisNewParty] = useState(false);
  const [isService, setisService] = useState(false);
  const [isOption, setisOption] = useState(false);
  const [strSearch, setstrSearch] = useState("");
  const [isBusy, setisBusy] = useState(false); // blocks double click on Add / Save

  const [EIListDT, setEIListDT] = useState([]);
  const [EIListTax, setEIListTax] = useState([]);
  const [EIListSummary, setEIListSummary] = useState([ZERO_SUMMARY]);
  const [EIItemRemark, setEIItemRemark] = useState([]);
  const [EIRootCalc, setEIRootCalc] = useState([]);
  const [BillType, setBillType] = useState([]);
  const [VenType, setVenType] = useState([]);
  const [EIType, setEIType] = useState([]);
  const [TaxType, setTaxType] = useState([]);
  const [NoFormat, setNoFormat] = useState([]);
  const [arrParty, setarrParty] = useState([]);
  const [ListValidateProperties, setListValidateProperties] = useState([]);
  const [ListTabOrder, setListTabOrder] = useState({
    txtPartyName: "",
    txtBillAddress: "",
    cbBillType: "",
    cbTaxType: "",
    txtTransNo: "",
    txtEINo: "",
    dpEIDate: "",

    txtBillDiscPer: "",
    txtBillDiscAmt: "",
    txtBillDiscValue: "",

    btnNew: "",
    btnModify: "",
    btnSave: "",
    btnClear: "",
    btnView: "",
    btnExportImport: "",
    btnPrint: "",
    btnCancel: "",
    btnClose: "",
    btnPrintSettings: "",
    btnHelp: "",
    txtRemark1: "",
    txtRemark2: "",
    txtRemark3: "",
    txtRemark4: "",
    btnRefresh: "",

    TabParty: "",
    TabVoucher: "",
    TabRemarks: "",
    TabSummary: "",
    TabTax: "",
    TabDiscount: "",
    TabName: "Party",

    ServiceListTab: "",
    ProductTableListTab: "",
    txtServiceName: "",
    txtRate: "",
    txtDiscount: "",
    btnAdd: "",
    isDiscPer: "",
  });

  const [isTransView, setisTransView] = useState(false);
  const [isViewBtn, setisViewBtn] = useState(true);
  const [isSaveBtn, setisSaveBtn] = useState(true);
  const [isDeleteBtn, setisDeleteBtn] = useState(true);
  const [objPermission, setobjPermission] = useState(null);

  const searchSeq = useRef(0); // ignore out-of-order vendor search responses
  const billDiscApplied = useRef({ per: 0, amt: 0 });
  const pageRef = useRef(null); // scroll container
  const vendorBoxRef = useRef(null); // outside-click detection for the vendor dropdown
  const fnRef = useRef({}); // always-latest handlers (confirm dialogs keep a callback until "Yes")
  const [pageH, setPageH] = useState(null);
  const [padTop, setPadTop] = useState(0);
  const [errs, setErrs] = useState({}); // inline field errors (Zoho style: red border + message, no popup)

  // only REAL items count (server may send blank placeholder rows with serId = 0)
  const arrRows = EIListDT.filter((d) => d.serId !== 0);
  const hasItems = arrRows.length > 0;
  //#endregion

  // FIX (screen could not be scrolled): give the page body an explicit height = viewport - its own top
  // offset and let IT scroll, whatever the parent CSS does. Action bar below is sticky.
  useLayoutEffect(() => {
    const fit = () => {
      if (!pageRef.current) return;
      const top = pageRef.current.getBoundingClientRect().top;
      setPageH(Math.max(360, Math.floor(window.innerHeight - Math.max(top, 0))));
      // If a fixed / sticky header floats OVER the top of this page (screenshot: row-1 labels
      // "Vendor Type / Vendor / Voucher No" hidden under the title bar) push the content below it.
      let over = 0;
      const x = Math.floor(window.innerWidth / 2);
      const y = Math.max(top, 0) + 2;
      (document.elementsFromPoint ? document.elementsFromPoint(x, y) : []).forEach(
        (el) => {
          if (pageRef.current.contains(el) || el === pageRef.current) return;
          if (el === document.documentElement || el === document.body) return;
          const pos = window.getComputedStyle(el).position;
          if (pos === "fixed" || pos === "sticky") {
            const b = el.getBoundingClientRect().bottom;
            if (b > y) over = Math.max(over, Math.ceil(b - Math.max(top, 0)));
          }
        }
      );
      setPadTop(over);
    };
    fit();
    const t = setTimeout(fit, 400); // late layout shifts (menu / fonts)
    window.addEventListener("resize", fit);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", fit);
    };
  }, []);

  // Vendor dropdown closes on OUTSIDE click (it used to close the moment the mouse left the box)
  useEffect(() => {
    if (!isOption) return undefined;
    const onDown = (e) => {
      if (vendorBoxRef.current && !vendorBoxRef.current.contains(e.target))
        setisOption(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [isOption]);

  // Ctrl+S = Save (same as Zoho / Tally style entry screens)
  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && String(e.key).toLowerCase() === "s") {
        e.preventDefault();
        fnRef.current.TrySave && fnRef.current.TrySave();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    Load_ExponeIncome();
    LoadPermission();
    // eslint-disable-next-line
  }, []);

  // FIX: permission was evaluated once on mount with iEIId = 0, so after opening a saved voucher
  // a user with "Create" but without "Modify" right could still update. Re-evaluate on iEIId change.
  useEffect(() => {
    if (!objPermission) {
      setisSaveBtn(true);
      setisDeleteBtn(true);
      setisViewBtn(true);
      return;
    }
    setisSaveBtn(iEIId > 0 ? !objPermission.isModify : !objPermission.isCreate);
    setisDeleteBtn(!objPermission.isDelete);
    setisViewBtn(!objPermission.isView);
  }, [objPermission, iEIId]);

  // API can answer with strStatus = Validation / Error even on HTTP 200
  const IsOk = (res) => {
    if (!res) return false;
    if (res.strStatus && res.strStatus !== "Success") {
      Show_Message(dispatch, res.strMessage || "Something went wrong", "error");
      return false;
    }
    return true;
  };

  const ApplySummary = (arrSummary) => {
    const list =
      Array.isArray(arrSummary) && arrSummary.length > 0
        ? arrSummary
        : [ZERO_SUMMARY];
    const S = list[0] || ZERO_SUMMARY;
    setEIListSummary(list);
    setiGoodsValue(S.goodsValue || 0);
    setiTotalTax(S.totalTax || 0);
    setiRountoff(S.roundOff || 0);
    setiTotalDisc(S.totalDiscount || 0);
    setstrNetAmt(fmtINR(S.netAmt));
  };

  const Load_ExponeIncome = async () => {
    const _LocalParems = await DecryptData(localStorage.jbctrlparams);
    const res = await API_FETCH(
      `ExpenseIncome/Load_ExpensseIncome/${Number(_LocalParems.Branch)}/${
        _LocalParems.DB
      }`,
      dispatch
    );
    if (!res) return;

    // Server now isolates every loader - show exactly which one failed instead of a blank screen
    if (res.arrLoadErrors && res.arrLoadErrors.length > 0) {
      Show_Message(
        dispatch,
        "Load failed for: " + res.arrLoadErrors.join(" | "),
        "error"
      );
    }

    setBillType(normalizeList(res.objBillType, "strBillType", "iBT_Id"));
    setTaxType(normalizeList(res.objTaxType, "strTaxType", "iTaxRelId"));
    setVenType(normalizeList(res.objVenType, "strVenTypeName", "iVenTypeId"));
    setEIType(normalizeList(res.objEIType, "strEITypeName", "iEITypeId"));

    const arrNo = res.objNoFormat || [];
    setNoFormat(arrNo);
    setstrTransNo(arrNo[0]?.strTransNo ?? "");
    setstrVouchNo(arrNo[0]?.strUserNo ?? "");

    setiTaxCalcOnId(Number(res.iTaxCalcOnId) || 0);
    setiBillTypeId(Number(res.lastBillType) || 0);
    setListValidateProperties(res.Transtab || []);
    TabOrderAssign(res.Transtab || []);

    ApplySummary([ZERO_SUMMARY]);
    setEIItemRemark([
      { strRemark1: "", strRemark2: "", strRemark3: "", strRemark4: "" },
    ]);
    setEIRootCalc([
      {
        dValu1: 1,
        dValue2: 1,
        dValue3: 1,
        dConstantValue: 1,
        dFinalValue: 1,
        strOp1: "0",
        strOp2: "0",
        strOp3: "0",
      },
    ]);
  };

  // Voucher No "Refresh" (server validation message already tells user to click it)
  const RefreshVoucherNo = async () => {
    if (iEIId > 0) return;
    const res = await API_FETCH(
      `ExpenseIncome/Load_NoFormat/${Number(_AuthParems.Branch)}/${
        _AuthParems.DB
      }`,
      dispatch
    );
    if (IsOk(res) && res.objNoFormat && res.objNoFormat.length > 0) {
      setNoFormat(res.objNoFormat);
      setstrTransNo(res.objNoFormat[0].strTransNo ?? "");
      setstrVouchNo(res.objNoFormat[0].strUserNo ?? "");
    }
  };

  const View_Party = async (PartyId) => {
    if (PartyId === undefined || PartyId === null || PartyId === "") {
      Show_Message(dispatch, "Vendor id missing in the search result", "error");
      return;
    }
    const res = await API_FETCH(
      `ExpenseIncome/View_Party/${PartyId}/${iVenTypeId}/${Number(
        _AuthParems.Branch
      )}/${_AuthParems.DB}`,
      dispatch
    );
    if (!res) {
      // API wrapper returned nothing = 404 / 401 / network. Do not leave the user guessing.
      Show_Message(
        dispatch,
        "Could not load the vendor (server did not answer). Please check the ExpenseIncome API is deployed.",
        "error"
      );
      return;
    }
    if (IsOk(res) && res.objPartyDetails) {
      const det = res.objPartyDetails;
      setiPartyId(PartyId);
      setstrPartyName(String(det[0] ?? ""));
      setstrPartyAdd(String(det[1] ?? ""));
      setiTaxRelId(Number(res.iTaxRelId) || 0);
      setisOption(false);
      setstrSearch("");
      if (!Number(res.iTaxRelId))
        Show_Message(
          dispatch,
          "Tax Type is not set for this vendor. Please update the vendor master.",
          "error"
        );
    }
  };

  const OnVenTypeChange = (val) => {
    const iNew = Number(val);
    if (iNew === iVenTypeId) return;
    setiVenTypeId(iNew);
    // vendor belongs to the old type -> must not stay selected
    setiPartyId(0);
    setstrPartyName("");
    setstrPartyAdd("");
    setiTaxRelId(0);
    setarrParty([]);
  };

  //#region Service row
  const Select_Service = (Ser) => {
    if (!Ser) return;
    setiSerId(Ser.serId ?? Ser.SerId ?? 0);
    setstrSerName(Ser.serName ?? Ser.SerName ?? "");
    const rate = Ser.rate ?? Ser.Rate;
    if (rate !== undefined && rate !== null) setdPriceRate(String(rate));
    setisService(false);
    setTimeout(() => $("#txtSerRate").focus().select(), 0);
  };

  const ValidateServiceRow = () => {
    const rate = Number(dPriceRate);
    const disc = Number(dItemDisc) || 0;
    let msg = "";
    if (iPartyId === 0) msg = "Please Select a Vendor First";
    else if (iTaxRelId === 0) msg = "Tax Type is Required. Please Re-select the Vendor";
    else if (Number(iSerId) === 0) msg = "Please Select a Service";
    else if (!Number.isFinite(rate) || rate <= 0)
      msg = "Cost Rate Must Be Greater Than Zero";
    else if (disc < 0) msg = "Discount Cannot Be Negative";
    else if (isDiscPer && disc > 100) msg = "Discount % Cannot Exceed 100";
    else if (!isDiscPer && disc > rate)
      msg = "Discount Amount Cannot Exceed the Cost Rate";
    if (msg) {
      Show_Message(dispatch, msg, "error");
      return false;
    }
    return true;
  };

  const Add_Service = async () => {
    if (isBusy || !ValidateServiceRow()) return;
    setisBusy(true);
    try {
      const res = await API_POST(
        "ExpenseIncome/Add_Service/",
        {
          bUpdateStatus: bUpdateStatus,
          iRowIndex: iRowIndex,
          iScrId: iScrId,
          iTaxRelId: iTaxRelId,
          iPartyId: iPartyId,
          iTaxCalcOnId: iTaxCalcOnId,
          iSerId: Number(iSerId),
          dPriceRate: Number(dPriceRate),
          dDiscountPer: isDiscPer ? Number(dItemDisc) : 0,
          dDiscountAmt: !isDiscPer ? Number(dItemDisc) : 0,
          // bill discount must be re-applied when a new row comes in
          dTBillDiscPer: Number(dBillDisPer) || 0,
          dTBillDiscAmt: Number(dBillDisAmt) || 0,
          dTBillDiscValue: Number(dBillDisValue) || 0,
          objBaseTransDT: EIListDT,
          objEntAddLess: [],
          objEntConRow: [],
          objEntTax: [],
          objItemRemark: EIItemRemark[0],
          objPenCon: [],
          objRootCalc: EIRootCalc[0],
          strColumn: "",
          strJobId: "",
          strProAttDTId: "",
          strReason: "",
          strSearch: "",
          strSetCurrentStatus: strSetCurrentStatus,
          strStoAttDTId: "",
          strTraAttDTId: "",
          iYearId: Number(_AuthParems.Year),
          strDBName: _AuthParems.DB,
          iRoleId: Number(_AuthParems.User),
          iBranchId: Number(_AuthParems.Branch),
        },
        dispatch
      );
      if (IsOk(res)) {
        setEIListDT(res.objEntDT);
        setEIListTax(res.objEntTax || []);
        ApplySummary(res.objEntSummary);
        if (res.dBillDiscValue !== undefined && res.dBillDiscValue !== null)
          setdBillDisValue(fmtNum(res.dBillDiscValue));
        Clear_Service();
        // ready for the next item (Zoho style - cursor goes back to Service Name)
        setTimeout(() => $("#txtSerName").focus(), 0);
      }
    } finally {
      setisBusy(false);
    }
  };

  const Clear_Service = () => {
    setiSerId(0);
    setstrSerName("");
    setdItemDisc(0);
    setdPriceRate("0");
    setbUpdateStatus(false);
    setisDiscPer(true);
  };

  // FIX: used PascalCase (SerInfo.SerId / SerName / Rate) while the table & API are camelCase
  // => double-click on a row filled the edit area with "undefined".
  const AssignSelectedService = (SerInfo, Index) => {
    setiRowIndex(Index);
    setbUpdateStatus(true);
    setiSerId(SerInfo.serId);
    setstrSerName(SerInfo.serName);
    setdPriceRate(String(SerInfo.rateWithoutTax ?? 0));
    const per = Number(SerInfo.itemDiscPer) || 0;
    const amt = Number(SerInfo.itemDiscAmt) || 0;
    setdItemDisc(per > 0 ? per : amt);
    setisDiscPer(per > 0 || amt === 0);
  };

  const DeleteService = async (iIndex) => {
    if (isBusy) return;
    setisBusy(true);
    try {
      const res = await API_POST(
        "ExpenseIncome/DeleteService/",
        {
          iRowIndex: iIndex,
          iScrId: iScrId,
          iTaxRelId: iTaxRelId,
          iPartyId: iPartyId,
          iTaxCalcOnId: iTaxCalcOnId,
          iSerId: 0,
          dPriceRate: 0,
          dDiscountPer: 0,
          dDiscountAmt: 0,
          dTBillDiscPer: Number(dBillDisPer) || 0,
          dTBillDiscAmt: Number(dBillDisAmt) || 0,
          objBaseTransDT: EIListDT,
          objEntAddLess: [],
          objEntConRow: [],
          objEntTax: [],
          objItemRemark: EIItemRemark[0],
          objPenCon: [],
          objRootCalc: EIRootCalc[0],
          strColumn: "",
          strJobId: "",
          strProAttDTId: "",
          strReason: "",
          strSearch: "",
          strSetCurrentStatus: strSetCurrentStatus,
          strStoAttDTId: "",
          strTraAttDTId: "",
          iYearId: Number(_AuthParems.Year),
          iBranchId: Number(_AuthParems.Branch),
          strDBName: _AuthParems.DB,
        },
        dispatch
      );
      if (IsOk(res)) {
        setEIListDT(res.objEIDT);
        setEIListTax(res.objTaxDT || []);
        ApplySummary(res.objEISummary); // summary panel (tax / round off) was NOT refreshed before
        const remaining = (res.objEIDT || []).filter((d) => d.serId !== 0);
        if (remaining.length === 0) {
          setdBillDisPer(0);
          setdBillDisAmt(0);
          setdBillDisValue(0);
          billDiscApplied.current = { per: 0, amt: 0 };
        } else if (res.dBillDiscValue !== undefined) {
          setdBillDisValue(fmtNum(res.dBillDiscValue));
        }
        Clear_Service(); // row indexes shifted - never keep a stale "edit row"
      }
    } finally {
      setisBusy(false);
    }
  };
  //#endregion

  const ViewClick = async (iVouchId) => {
    const res = await API_FETCH(
      `ExpenseIncome/View_Voucher/${iVouchId}/${Number(_AuthParems.Branch)}/${
        _AuthParems.DB
      }`,
      dispatch
    );
    if (IsOk(res)) {
      const HT = res.objEntHT[0];
      setiEIId(iVouchId);
      setstrPartyName(res.objPartyList[0] ?? "");
      setstrPartyAdd(res.objPartyList[1] ?? "");
      setiPartyId(HT.iPartyId);
      setNoFormat([
        {
          iNumSeqNo: HT.iNumSeqNo,
          strPrefix: HT.strPrefix,
          strCompCode: HT.strCompCode,
          strFinanFrom: HT.strFinanFrom,
          strTransNo: HT.strTransNo,
        },
      ]);
      setstrTransNo(HT.strTransNo ?? "");
      setstrVouchNo(HT.strVouchNo ?? "");
      setstrVouchDate(toInputDate(HT.strVouchDate, ""));
      if (!toInputDate(HT.strVouchDate, ""))
        Show_Message(
          dispatch,
          "This voucher has no date saved. Please select the voucher date before saving.",
          "info"
        );
      setiBillTypeId(HT.iBillTypeId);
      // FIX: Expense/Income type and Vendor type were never restored -> an INCOME voucher
      // opened for edit was silently saved back as EXPENSE (default 1) with vendor type 2.
      setiEITypeId(Number(HT.iEITypeId) || 1);
      setiVenTypeId(Number(HT.iVenTypeId) || 2);
      setiTaxCalcOnId(HT.iTaxCalcOnId);
      setiTaxRelId(HT.iTaxTypeId);
      setstrRemark1(HT.strRemark1 ?? "");
      setstrRemark2(HT.strRemark2 ?? "");
      setstrRemark3(HT.strRemark3 ?? "");
      setstrRemark4(HT.strRemark4 ?? "");
      setdBillDisPer(HT.dTBillDiscPer ?? 0);
      setdBillDisAmt(HT.dTBillDiscAmt ?? 0);
      setdBillDisValue(HT.dTBillDiscValue ?? 0);
      billDiscApplied.current = {
        per: Number(HT.dTBillDiscPer) || 0,
        amt: Number(HT.dTBillDiscAmt) || 0,
      };
      // FIX: old code converted null -> "" for every field. "" in a decimal property makes the
      // later Update request fail model binding. Keep real values; table cells are null-safe now.
      setEIListDT(res.objEntDT || []);
      setEIListTax(res.objEntTax || []);
      ApplySummary(res.objEntSummary);
      Clear_Service();
      setisTransView(false);
    }
  };

  const DeleteClick = async () => {
    // FIX: endpoint is [HttpPost] but UI used GET (API_FETCH) => 405 on every delete.
    const res = await API_POST(
      `ExpenseIncome/Delete_ExpenseIncome/${iEIId}/${Number(
        _AuthParems.Branch
      )}/${_AuthParems.DB}`,
      {},
      dispatch
    );
    if (IsOk(res)) {
      ClearClick();
      // FIX: used to pass the whole response OBJECT to the toast
      Show_Message(dispatch, res.strMessage || "Deleted Successfully", "success");
    }
  };

  // All mandatory checks BEFORE the "Do you want to save?" prompt (Zoho style)
  const ValidateForm = () => {
    const e = {};
    const yr = Number(String(strVouchDate || "").substring(0, 4));
    if (iVenTypeId === 0) e.venType = "Vendor Type is required";
    if (iPartyId === 0) e.vendor = "Please select a vendor";
    if (!String(strVouchNo).trim()) e.vouchNo = "Voucher number is required";
    if (!strVouchDate) e.date = "Voucher date is required";
    else if (yr < 2000 || yr > 2100) e.date = "Please select a valid date";
    if (iEITypeId === 0) e.eiType = "Expense / Income type is required";
    if (iBillTypeId === 0) e.billType = "Bill type is required";
    if (iTaxRelId === 0 && iPartyId !== 0)
      e.taxType = "Tax type missing. Please re-select the vendor";
    setErrs(e);
    const FOCUS = {
      vendor: "#txtVendor",
      vouchNo: "#txtVouchNo",
      date: "#txtVouchDate",
    };
    const first = Object.keys(e)[0];
    if (first) {
      if (FOCUS[first]) setTimeout(() => $(FOCUS[first]).focus(), 0);
      return false;
    }
    // non-field problems still use the message box
    let msg = "";
    if (EIListDT.filter((d) => d.serId !== 0).length === 0)
      msg = "Atleast One Item is Required per Bill";
    else if (NoFormat.length === 0)
      msg = "Voucher Number Format Not Loaded. Please Click Clear and Try Again";
    if (msg) {
      Show_Message(dispatch, msg, "error");
      setTimeout(() => $("#txtSerName").focus(), 0);
      return false;
    }
    return true;
  };

  // an inline error disappears as soon as the user fixes that field
  useEffect(() => {
    setErrs((prev) => {
      if (Object.keys(prev).length === 0) return prev;
      const n = { ...prev };
      if (iPartyId !== 0) delete n.vendor;
      if (iTaxRelId !== 0) delete n.taxType;
      if (String(strVouchNo).trim()) delete n.vouchNo;
      if (strVouchDate) delete n.date;
      if (iBillTypeId !== 0) delete n.billType;
      if (iEITypeId !== 0) delete n.eiType;
      if (iVenTypeId !== 0) delete n.venType;
      return Object.keys(n).length === Object.keys(prev).length ? prev : n;
    });
  }, [iPartyId, iTaxRelId, strVouchNo, strVouchDate, iBillTypeId, iEITypeId, iVenTypeId]);

  const errStyle = (k) => (errs[k] ? { borderColor: "#d93025", boxShadow: "0 0 0 1px #d93025" } : {});
  const ErrMsg = ({ k }) =>
    errs[k] ? (
      <div role="alert" style={{ color: "#d93025", fontSize: 12, marginTop: 2 }}>
        {errs[k]}
      </div>
    ) : null;

  const SaveClick = async () => {
    if (isBusy) return;
    if (!ValidateForm()) return;
    setisBusy(true);
    try {
      const S = EIListSummary[0] || ZERO_SUMMARY;
      const EIListHT = {
        iEIId: iEIId,
        iBranchId: Number(_AuthParems.Branch),
        iUserId: Number(_AuthParems.User), // CreatedBy / ModifiedBy were always 0 (confirm this is the user id)
        iTitleTag: iScrId,
        iPartyId: iPartyId,
        iNumSeqNo: NoFormat[0].iNumSeqNo,
        strPrefix: NoFormat[0].strPrefix,
        strCompCode: NoFormat[0].strCompCode,
        strFinanFrom: NoFormat[0].strFinanFrom,
        strTransNo: NoFormat[0].strTransNo,
        strVouchNo: String(strVouchNo).trim(),
        strVouchDate: strVouchDate,
        iBillTypeId: iBillTypeId,
        iTaxCalcOnId: iTaxCalcOnId,
        iTaxTypeId: iTaxRelId,
        iVenTypeId: iVenTypeId,
        iEITypeId: iEITypeId,
        strRemark1: strRemark1,
        strRemark2: strRemark2,
        strRemark3: strRemark3,
        strRemark4: strRemark4,
        dTBillDiscPer: Number(dBillDisPer) || 0,
        dTBillDiscAmt: Number(dBillDisAmt) || 0,
        dTBillDiscValue: Number(dBillDisValue) || 0,
        dTotGoodval: Number(S.goodsValue) || 0,
        dTotDiscount: Number(S.totalDiscount) || 0,
        dTotTax: Number(S.totalTax) || 0,
        dRoundOff: Number(S.roundOff) || 0,
        dNetAmt: Number(S.netAmt) || 0,
      };
      const res = await API_POST(
        "ExpenseIncome/InsUpd_ExpenseIncome/",
        {
          objEntSI: EIListHT,
          objBaseTransDT: EIListDT,
          objEntTax: EIListTax,
          strDBName: _AuthParems.DB,
        },
        dispatch
      );
      // FIX: "Validation" / "Error" responses used to clear the form and show a green "success" toast
      if (IsOk(res)) {
        ClearClick();
        Show_Message(dispatch, res.strMessage, "success");
      }
    } finally {
      setisBusy(false);
    }
  };

  const ClearClick = () => {
    setErrs({});
    setstrPartyName("");
    setstrPartyAdd("");
    setstrTransNo("");
    setstrVouchNo("");
    setstrVouchDate(todayLocal());
    setiTaxRelId(0);
    setiBillTypeId(0);
    setiEITypeId(1);
    setiVenTypeId(2);
    setstrRemark1("");
    setstrRemark2("");
    setstrRemark3("");
    setstrRemark4("");
    setiEIId(0);
    setiRowIndex(0);
    setiScrId(66);
    setiPartyId(0);
    setdBillDisPer(0);
    setdBillDisAmt(0);
    setdBillDisValue(0);
    billDiscApplied.current = { per: 0, amt: 0 };
    setEIListDT([]);
    setEIListTax([]);
    setarrParty([]);
    setstrSearch("");
    setisOption(false);
    ApplySummary([ZERO_SUMMARY]);
    Clear_Service();
    Load_ExponeIncome();
  };

  // validate first, THEN ask for confirmation. Confirm dialog gets a wrapper that always calls the
  // LATEST SaveClick (the old code kept the render-time closure -> a bill discount that came back
  // while the dialog was open was shown on screen but NOT saved).
  const TrySave = async () => {
    if (isSaveBtn || isBusy) return;
    // Ctrl+S (or a quick click) while the cursor is still inside a Bill Discount box: blur has not
    // fired yet, so totals on screen were NOT recalculated for the typed discount. Settle it first.
    const pend = billDiscApplied.current;
    if ((Number(dBillDisPer) || 0) !== pend.per) {
      if (!(await CalcBillDisc("Per"))) return;
    } else if ((Number(dBillDisAmt) || 0) !== pend.amt) {
      if (!(await CalcBillDisc("Amt"))) return;
    }
    if (ValidateForm() && PropertiesValidation()) {
      Ask_Question(
        dispatch,
        () => fnRef.current.SaveClick(),
        iEIId > 0 ? "Do You Want to Update ?" : "Do You Want to Save ?"
      );
    }
  };
  fnRef.current = { SaveClick, DeleteClick, DeleteService, TrySave };

  // Unsaved changes guard (Zoho asks before you lose a half filled bill)
  const isDirty =
    iEIId === 0 &&
    (hasItems ||
      iPartyId > 0 ||
      strRemark1 !== "" ||
      strRemark2 !== "" ||
      strRemark3 !== "" ||
      strRemark4 !== "");
  useEffect(() => {
    if (!isDirty) return undefined;
    const warn = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [isDirty]);

  const CloseClick = () => {
    if (isDirty)
      Ask_Question(
        dispatch,
        () => window.history.back(),
        "Unsaved changes will be lost. Do You Want to Close ?"
      );
    else window.history.back();
  };

  //#region Bill discount
  // Calculated on blur (not on every keystroke): old code fired one API call per key press,
  // responses could return out of order, and "0.5" could not even be typed (Number("0.") -> 0).
  const CalcBillDisc = async (mode) => {
    const raw = mode === "Per" ? dBillDisPer : dBillDisAmt;
    const v = Number(raw) || 0;
    const prev = billDiscApplied.current;
    if ((mode === "Per" ? prev.per : prev.amt) === v) return true; // nothing changed

    const arrItems = EIListDT.filter((d) => d.serId !== 0);
    let msg = "";
    if (v < 0) msg = "Bill Discount Cannot Be Negative";
    else if (mode === "Per" && v > 100) msg = "Bill Discount % Cannot Exceed 100";
    else if (v > 0 && arrItems.length === 0)
      msg = "Please Add Atleast One Item Before Applying Bill Discount";
    else if (mode === "Amt" && v > Number(iGoodsValue) - Number(iTotalDisc))
      msg = "Bill Discount Amount Cannot Exceed the Bill Value";
    if (msg) {
      Show_Message(dispatch, msg, "error");
      setdBillDisPer(prev.per);
      setdBillDisAmt(prev.amt);
      return false;
    }
    if (arrItems.length === 0) {
      setdBillDisPer(0);
      setdBillDisAmt(0);
      return true;
    }

    setisBusy(true); // Save is disabled until the recalculated totals are back
    let res = null;
    try {
      res = await API_POST(
      "ExpenseIncome/CalculateBillDiscount/",
      {
        strCase: mode === "Per" ? "BillDicPer" : "BillDicAmt",
        iScrId: iScrId,
        // FIX: UI sent iTaxTypeId but the server model reads iTaxRelId -> tax recalculated with 0
        iTaxTypeId: iTaxRelId,
        iTaxRelId: iTaxRelId,
        iTaxCalcOnId: iTaxCalcOnId,
        iPartyId: iPartyId,
        // FIX: server decides Per / Amt by "dTBillDiscPer > 0". If the user had a % and then typed an
        // amount the amount was ignored. Send only the field being edited.
        dTBillDiscPer: mode === "Per" ? v : 0,
        dTBillDiscAmt: mode === "Amt" ? v : 0,
        dTBillDiscValue: Number(dBillDisValue) || 0,
        objBaseTransDT: EIListDT,
        iYearId: Number(_AuthParems.Year),
        iBranchId: Number(_AuthParems.Branch),
        strDBName: _AuthParems.DB,
      },
      dispatch
      );
    } finally {
      setisBusy(false);
    }
    if (IsOk(res)) {
      setEIListDT(res.objEIDT);
      setEIListTax(res.objTaxDT || []);
      ApplySummary(res.objEISummary); // Tax / Round off panel was stale before
      setdBillDisPer(fmtNum(res.dBillDiscPer));
      setdBillDisAmt(fmtNum(res.dBillDiscAmt));
      setdBillDisValue(fmtNum(res.dBillDiscValue));
      billDiscApplied.current = {
        per: Number(res.dBillDiscPer) || 0,
        amt: Number(res.dBillDiscAmt) || 0,
      };
      return true;
    }
    setdBillDisPer(prev.per);
    setdBillDisAmt(prev.amt);
    return false;
  };
  //#endregion

  const TabOrderAssign = (EntProperties) => {
    const updates = {};
    const arrStops = (EntProperties || []).filter(
      (Data) => Data.isTabStop === true
    );
    let maxTab = 0;
    arrStops.forEach((P) => {
      // FIX: "btnRefresh            " (with trailing spaces) could never match
      const key = TAB_KEYS[String(P.strCtrlName || "").trim()];
      if (key) updates[key] = P.iTabIndex;
      if (Number(P.iTabIndex) > maxTab) maxTab = Number(P.iTabIndex);
    });
    sessionStorage.maxTab = maxTab;
    // FIX: old code mutated the state object and set the same reference back (React skips that re-render)
    setListTabOrder((prev) => ({ ...prev, ...updates }));
  };

  const KeyDown = (e) => {
    const maxTab = Number(sessionStorage.maxTab) || 0;
    const active = document.activeElement.tabIndex;
    const isNext = e.key === "Enter" || e.key === "ArrowDown";
    const isPrev = e.key === "ArrowUp";
    if (!isNext && !isPrev) return;
    const step = isNext ? 1 : -1;
    const target = active + step;
    // grid is a single tab stop: jump into the first row when it has items
    if (target === Number(ListTabOrder.ServiceListTab) && hasItems) {
      $(".ReactTable .rt-tbody .rt-tr:eq(0)").focus();
      return;
    }
    // skips disabled / hidden stops (bill discount boxes are disabled until an item exists)
    focusTab(active >= 0 ? active : -1, step, maxTab);
  };

  // DB driven mandatory rules (Transtab). Kept as is.
  const PropertiesValidation = () => {
    var ErrorMsg = true;
    let ValidateItem = ListValidateProperties.filter(
      (Data) => Data.isValidate === true
    );
    for (var i = 0; i < ValidateItem.length; i++) {
      switch (String(ValidateItem[i].strCtrlName).trim()) {
        case "txtPartyName":
          ErrorMsg = strPartyName === "" ? false : true;
          break;
        case "cbBillType":
          ErrorMsg = parseFloat(iBillTypeId) === 0 ? false : true;
          break;
        case "cbTaxType":
          ErrorMsg = parseFloat(iTaxRelId) === 0 ? false : true;
          break;
        case "txtTransNo":
          ErrorMsg = strTransNo === "" ? false : true;
          break;
        case "txtEINo":
          ErrorMsg = strVouchNo === "" ? false : true;
          break;
        case "txtRemark1":
          ErrorMsg = strRemark1 === "" ? false : true;
          break;
        case "txtRemark2":
          ErrorMsg = strRemark2 === "" ? false : true;
          break;
        case "txtRemark3":
          ErrorMsg = strRemark3 === "" ? false : true;
          break;
        case "txtRemark4":
          ErrorMsg = strRemark4 === "" ? false : true;
          break;
        default:
          break;
      }
      if (ErrorMsg === false) {
        Show_Message(dispatch, ValidateItem[i].strErrorMsg, "error");
        return ErrorMsg;
      }
    }
    return ErrorMsg;
  };

  const Searchparty = async (SearchText) => {
    setstrSearch(SearchText);
    const seq = ++searchSeq.current;
    const parems = {
      iScrId: 3,
      iPartyId: 0,
      iVenType: iVenTypeId, // PartyTrans/Search_Party filters on iVenType
      strColName: "SuppName",
      strSearch: SearchText,
      strDBName: _AuthParems.DB,
      iBranchId: Number(_AuthParems.Branch),
    };
    const res = await API_POST(`PartyTrans/Search_Party`, parems, dispatch);
    // slower old response must not overwrite a newer one
    if (res && seq === searchSeq.current) {
      const arr = normalizeParties(res);
      if ((res.EntParty || []).length > 0 && arr.length === 0)
        console.error("Search_Party: unknown row shape", res.EntParty[0]);
      setarrParty(arr);
    }
  };

  const LoadPermission = async () => {
    const AuthParems = await DecryptData(localStorage.jbctrlparams);
    const ListMenu = ((AuthParems && AuthParems.AccountsPer) || []).filter(
      (Data) => Data.iScrId === 66
    )[0];
    // no permission row => everything stays disabled (fail closed) instead of crashing
    setobjPermission(ListMenu || null);
  };

  const columns = [
    {
      Header: "SNo",
      accessor: "sNo",
      maxWidth: 70,
      style: { justifyContent: "center" },
    },
    {
      Header: "Service Name",
      accessor: "serName",
      minWidth: 200,
      style: { justifyContent: "left" },
    },
    {
      Header: "Rate W/O Tax",
      accessor: "rateWithoutTax",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Rate + Tax",
      accessor: "rateWithTax",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Goods Value",
      accessor: "goodsValue",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Disc %",
      accessor: "itemDiscPer",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Disc Amt",
      accessor: "itemDiscAmt",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Disc Value",
      accessor: "itemDiscValue",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Bill Disc",
      accessor: "billDiscValue",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Tax %",
      accessor: "taxPer",
      Cell: numCell,
      style: { justifyContent: "center" },
    },
    {
      Header: "Tax Amt",
      accessor: "taxAmt",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Amount",
      accessor: "itemAmt",
      Cell: numCell,
      style: { justifyContent: "right" },
    },
    {
      Header: "Options",
      accessor: "options",
      maxWidth: 90,
      style: { justifyContent: "center" },
    },
  ];

  // The ReactTable wrapper prints row[accessor] as is (it ignores Cell / function accessors), so the rows
  // given to it are display copies: numbers formatted 1,00,000.00 and the Options icons as elements.
  // Raw rows (EIListDT) stay untouched - double click looks the raw row up again by sNo.
  const NUM_KEYS = [
    "rateWithoutTax",
    "rateWithTax",
    "goodsValue",
    "itemDiscPer",
    "itemDiscAmt",
    "itemDiscValue",
    "billDiscValue",
    "taxPer",
    "taxAmt",
    "itemAmt",
  ];
  const viewRows = arrRows.map((r) => {
    const v = { ...r };
    NUM_KEYS.forEach((k) => {
      v[k] = fmtView(r[k]);
    });
    v.options = (
      <div>
        <i
          title="Edit item"
          style={{ cursor: "pointer", marginRight: 14 }}
          onClick={() => {
            const iReal = EIListDT.findIndex((d) => d.sNo === r.sNo);
            AssignSelectedService(r, iReal >= 0 ? iReal : 0);
          }}
          className="far fa-edit"
        ></i>
        <i
          title="Remove item"
          style={{ cursor: "pointer" }}
          onClick={() =>
            Ask_Question(
              dispatch,
              () => fnRef.current.DeleteService(r.sNo),
              "Do You Want to Remove this Item ?"
            )
          }
          className="far fa-trash-alt"
        ></i>
      </div>
    );
    return v;
  });

  const isPartyLocked = iEIId > 0 || (iPartyId > 0 && hasItems);

  return (
    <>
      <SideMenu ScrId={iScrId} />
      <div
        className="Trans-container"
        ref={pageRef}
        style={
          pageH
            ? {
                height: pageH,
                overflowY: "auto",
                overflowX: "hidden",
                paddingTop: padTop || undefined,
                boxSizing: "border-box",
              }
            : undefined
        }
      >
        <div className="d-flex justify-content-end mt-1">
          <span
            style={{
              fontSize: 12,
              fontWeight: 600,
              padding: "2px 10px",
              borderRadius: 12,
              background: iEIId > 0 ? "#fff4e5" : "#e6f4ea",
              color: iEIId > 0 ? "#b45f06" : "#1e7e34",
            }}
          >
            {iEIId > 0 ? "EDITING : " + strVouchNo : "NEW VOUCHER"}
          </span>
        </div>
        {/* ROW 1 : Vendor Type -> Vendor -> Voucher No -> Date -> Trans No */}
        <div className="row mt-2">
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Vendor Type <span className="danger">*</span>
            </label>
            <CustomizedSelectoption
              optionparem="isoptionShow"
              showoption={_Selectparem.isoptionShow}
              placeholder="Select Vendor Type"
              select_value={OnVenTypeChange}
              btnname="Location"
              btnshow={false}
              show_popup=""
              valueonly={true}
              defaultval={iVenTypeId}
              displayName="strVenTypeName"
              disvalue="iVenTypeId"
              arrydata={VenType}
              disabled={isPartyLocked}
              EmptVal="Vendor Type "
            />
          </div>
          <div className="col-md-4 col-sm-12 mt-1">
            <label>
              Vendor <span className="danger">*</span>
            </label>
            <div className="custom-select" ref={vendorBoxRef}>
              <input
                className="form-control"
                disabled={isPartyLocked}
                type="text"
                placeholder="Select Vendor"
                id="txtVendor"
                style={errStyle("vendor")}
                // FIX: defaultValue is only read once, so the name never changed after selecting / clearing.
                value={strPartyName}
                readOnly
                aria-label="Vendor"
                onClick={(e) => {
                  if (isOption) setisOption(false);
                  else {
                    setisOption(true);
                    Searchparty("");
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Escape") setisOption(false);
                  else if (e.key === "Enter" || e.key === "F2") {
                    e.preventDefault();
                    if (!isPartyLocked && !isOption) {
                      setisOption(true);
                      Searchparty("");
                    }
                  } else KeyDown(e);
                }}
                tabIndex={ListTabOrder.txtPartyName}
              />
              <i className="fa-solid fa-caret-down"></i>
              {isOption && (
                <div className="custom-option">
                  <div className="search-option">
                    <input
                      type="text"
                      placeholder="Search Vendor"
                      value={strSearch}
                      onChange={(e) => Searchparty(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "ArrowDown") {
                          $(".option-list [tabindex=0]").focus();
                        }
                        if (e.key === "Escape") setisOption(false);
                      }}
                      autoFocus
                    />
                    {arrParty.length === 0 && <span> No Records Found</span>}
                  </div>
                  <div className="option-list">
                    {arrParty.map((Vendor, Index) => (
                      <button
                        type="button"
                        key={Index}
                        tabIndex={Index}
                        onClick={(e) => View_Party(Vendor.partyId)}
                        onKeyDown={(e) => {
                          let arrlength = arrParty.length - 1;
                          if (e.key === "ArrowDown") {
                            if (arrlength === Index)
                              $(`.option-list [tabindex=0]`).focus();
                            else
                              $(`.option-list [tabindex=${Index + 1}]`).focus();
                          }
                          if (e.key === "ArrowUp") {
                            if (Index === 0)
                              $(`.option-list [tabindex=${arrlength}]`).focus();
                            else
                              $(`.option-list [tabindex=${Index - 1}]`).focus();
                          }
                          if (e.key === "Enter") View_Party(Vendor.partyId);
                          if (e.key === "Escape") setisOption(false);
                        }}
                      >
                        {Vendor.partyName}
                      </button>
                    ))}
                  </div>
                  <div className="popup-footer">
                    <div className="popup-btn-group">
                      {/* FIX: toggled isServiceVendore but the popup renders on isNewParty => button did nothing */}
                      <button
                        type="button"
                        className="btn-fabgreen"
                        onClick={(e) => setisNewParty(true)}
                      >
                        <i className="fa-solid fa-circle-plus"></i>
                        Create Vendor
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <ErrMsg k="vendor" />
          </div>
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Voucher No <span className="danger">*</span>
            </label>
            <div className="d-inline-flex " style={{ width: "100%" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Voucher Number"
                id="txtVouchNo"
                style={errStyle("vouchNo")}
                value={strVouchNo}
                maxLength={30}
                tabIndex={ListTabOrder.txtEINo}
                onKeyDown={(e) => KeyDown(e)}
                onChange={(e) => setstrVouchNo(e.target.value)}
              />
              <button
                type="button"
                className="btn-fabgreen"
                title="Get next voucher number"
                disabled={iEIId > 0}
                tabIndex={ListTabOrder.btnRefresh}
                onClick={RefreshVoucherNo}
              >
                <i className="fas fa-sync-alt"></i>
              </button>
            </div>
            <ErrMsg k="vouchNo" />
          </div>
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Date <span className="danger">*</span>
            </label>
            <input
              type="date"
              name="strVouchDate"
              id="txtVouchDate"
              style={errStyle("date")}
              className="form-control"
              value={strVouchDate}
              // FIX: this used setstrVouchNo => changing the date overwrote the VOUCHER NUMBER with the date
              onChange={(e) => setstrVouchDate(e.target.value)}
              tabIndex={ListTabOrder.dpEIDate}
              onKeyDown={(e) => KeyDown(e)}
            />
            <ErrMsg k="date" />
          </div>
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Trans No <span className="danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              // FIX: defaultValue + readOnly => Trans No stayed blank after async load / clear / view
              value={strTransNo}
              tabIndex={ListTabOrder.txtTransNo}
              onKeyDown={(e) => KeyDown(e)}
              readOnly
            />
          </div>
        </div>

        {/* ROW 2 : Types + Address */}
        <div className="row mt-2">
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Expense / Income <span className="danger">*</span>
            </label>
            <CustomizedSelectoption
              optionparem="isoptionShow3"
              showoption={_Selectparem.isoptionShow3}
              placeholder="Expense Income Type"
              select_value={(val) => setiEITypeId(Number(val))}
              btnname="Expense Income"
              btnshow={false}
              show_popup=""
              valueonly={true}
              defaultval={iEITypeId}
              displayName="strEITypeName"
              disvalue="iEITypeId"
              arrydata={EIType}
              disabled={iEIId > 0}
              EmptVal="Expense Income"
            />
          </div>
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Bill Type <span className="danger">* </span>
            </label>
            <CustomizedSelectoption
              optionparem="isoptionShow1"
              showoption={_Selectparem.isoptionShow1}
              placeholder="Bill Type"
              select_value={(val) => setiBillTypeId(Number(val))}
              taborder={ListTabOrder.cbBillType}
              keydown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown");
                else KeyDown(e);
              }}
              btnname="Bill Type"
              btnshow={false}
              show_popup=""
              valueonly={true}
              defaultval={iBillTypeId}
              displayName="strBillType"
              disvalue="iBT_Id"
              arrydata={BillType}
              disabled={false}
              EmptVal="Bill Type"
            />
            <ErrMsg k="billType" />
          </div>
          <div className="col-md-2 col-sm-6 mt-1">
            <label>
              Tax Type <span className="danger">* </span>
            </label>
            <CustomizedSelectoption
              optionparem="isoptionShow2"
              showoption={_Selectparem.isoptionShow2}
              placeholder="Tax Type"
              taborder={ListTabOrder.cbTaxType}
              keydown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown");
                else KeyDown(e);
              }}
              btnname="Tax Type"
              btnshow={false}
              show_popup=""
              valueonly={true}
              defaultval={iTaxRelId}
              displayName="strTaxType"
              disvalue="iTaxRelId"
              arrydata={TaxType}
              disabled={true}
              EmptVal="Tax Type"
            />
            <ErrMsg k="taxType" />
          </div>
          <div className="col-md-6 col-sm-12 mt-1">
            <label>Address</label>
            <textarea
              className="form-control rounded"
              aria-label="Vendor address"
              placeholder="Address of Vendor"
              style={{
                height: "64px",
                whiteSpace: "break-spaces",
                overflow: "auto",
                maxHeight: "64px",
                background: "rgb(238,238,238)",
              }}
              id="txtPartyDetails"
              value={strPartyAdd}
              // grey background = read only; address comes from the vendor master
              readOnly
              tabIndex={ListTabOrder.txtBillAddress}
              onKeyDown={(e) => KeyDown(e)}
            ></textarea>
          </div>
        </div>

        {/* ROW 3 : Remarks */}
        <div className="row mt-2">
          <div className="col-md-3 col-sm-6 mt-1">
            <label>Remark 1</label>
            <input
              type="text"
              aria-label="Remark 1"
              className="form-control"
              placeholder="Enter Remark 1"
              name="strRemark1"
              maxLength={200}
              onChange={(e) => setstrRemark1(e.target.value)}
              value={strRemark1}
              tabIndex={ListTabOrder.txtRemark1}
              onKeyDown={(e) => KeyDown(e)}
            />
          </div>
          <div className="col-md-3 col-sm-6 mt-1">
            <label>Remark 2</label>
            <input
              type="text"
              aria-label="Remark 2"
              className="form-control"
              placeholder="Enter Remark 2"
              name="strRemark2"
              maxLength={200}
              onChange={(e) => setstrRemark2(e.target.value)}
              value={strRemark2}
              tabIndex={ListTabOrder.txtRemark2}
              onKeyDown={(e) => KeyDown(e)}
            />
          </div>
          <div className="col-md-3 col-sm-6 mt-1">
            <label>Remark 3</label>
            <input
              type="text"
              aria-label="Remark 3"
              className="form-control"
              placeholder="Enter Remark 3"
              name="strRemark3"
              maxLength={200}
              onChange={(e) => setstrRemark3(e.target.value)}
              value={strRemark3}
              tabIndex={ListTabOrder.txtRemark3}
              onKeyDown={(e) => KeyDown(e)}
            />
          </div>
          <div className="col-md-3 col-sm-6 mt-1">
            <label>Remark 4</label>
            <input
              type="text"
              aria-label="Remark 4"
              className="form-control"
              placeholder="Enter Remark 4"
              name="strRemark4"
              maxLength={200}
              onChange={(e) => setstrRemark4(e.target.value)}
              value={strRemark4}
              tabIndex={ListTabOrder.txtRemark4}
              onKeyDown={(e) => KeyDown(e)}
            />
          </div>
        </div>

        {/* ITEM ENTRY + TABLE */}
        <div className="row mt-2">
          <div className="col-md-4 col-sm-12">
            <label>Service Name</label>
            <div className="custom-select">
              <input
                id="txtSerName"
                className="form-control"
                disabled={false}
                type="text"
                placeholder="Select Service"
                value={strSerName}
                // FIX: onChange used to toggle the popup on every keystroke. It is a picker, not a text box.
                readOnly
                onClick={(e) => setisService(true)}
                tabIndex={ListTabOrder.txtServiceName}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === "F2") {
                    e.preventDefault();
                    setisService(true);
                  } else KeyDown(e);
                }}
              />
              <i className="fa-solid fa-caret-down"></i>
            </div>
          </div>
          <div className="col-md-2 col-sm-6 ">
            <label>Cost Rate</label>
            <input
              type="text"
              inputMode="decimal"
              aria-label="Cost rate"
              className="form-control"
              name="dPriceRate"
              id="txtSerRate"
              value={dPriceRate}
              // FIX: letters could be typed -> Number("abc") = NaN -> null sent to the API
              onChange={(e) => setdPriceRate(cleanDecimal(e.target.value))}
              onClick={(e) => e.target.select()}
              tabIndex={ListTabOrder.txtRate}
              onKeyDown={(e) => KeyDown(e)}
            />
          </div>
          <div className="col-md-2 col-sm-6 ">
            <label>Discount</label>
            <div className="trancdisc">
              <input
                type="text"
                inputMode="decimal"
                aria-label="Item discount"
                className="form-control"
                value={dItemDisc}
                onClick={(e) => e.target.select()}
                onChange={(e) => setdItemDisc(cleanDecimal(e.target.value))}
                tabIndex={ListTabOrder.txtDiscount}
                onKeyDown={(e) => KeyDown(e)}
                onBlur={(e) => setdItemDisc(Number(e.target.value).toFixed(2))}
              />
              {/* FIX: highlight was toggled with jQuery AND state -> they drifted apart after Clear / row edit. State only now. */}
              <button
                type="button"
                className={`btn-fabgreen ${isDiscPer ? "active" : ""}`}
                title={isDiscPer ? "Discount in %" : "Discount in amount"}
                onClick={(e) => setisDiscPer(!isDiscPer)}
                onKeyDown={(e) => {
                  if (e.key === "ArrowRight" || e.key === "ArrowLeft")
                    setisDiscPer(!isDiscPer);
                  else KeyDown(e);
                }}
              >
                {isDiscPer ? "%" : "₹"}
              </button>
            </div>
          </div>
          <div className="col-md-2 col-sm-6 ">
            <div className="trans-inputbtn">
              {/* FIX: explicit Enter handler + native button click = TWO Add_Service calls (duplicate row) */}
              <button
                type="button"
                disabled={isBusy}
                onClick={Add_Service}
                tabIndex={ListTabOrder.btnAdd}
                onKeyDown={(e) => {
                  if (e.key !== "Enter") KeyDown(e);
                }}
              >
                {bUpdateStatus ? "Update" : "Add"}
              </button>
              <button type="button" onClick={(e) => Clear_Service()}>
                Clear
              </button>
            </div>
          </div>
          <ReactTable
            columns={columns}
            data={viewRows}
            minRows={5}
            row_click={(ServInfo, Index) => {}}
            row_doubleclick={async (ServInfo, Index) => {
              // server row index (not the visible index)
              const iReal = EIListDT.findIndex((d) => d.sNo === ServInfo.sNo);
              AssignSelectedService(
                iReal >= 0 ? EIListDT[iReal] : ServInfo,
                iReal >= 0 ? iReal : Index
              );
            }}
            background={true}
            className="full-table"
            tabIndex={ListTabOrder.ProductTableListTab}
            KeyDown={(e) => KeyDown(e)}
          />
        </div>

        {/* SUMMARY */}
        <div className="row mt-2">
          <div className="col-sm-12 col-md-4 ">
            <div className="sum-container">
              <div className="Exp-sum-lbl">
                <label>Goods Value</label>
                <label>{fmtView(iGoodsValue)}</label>
              </div>
              <div className="Exp-sum-lbl">
                <label>Discount</label>
                <label>{fmtView(iTotalDisc)}</label>
              </div>
              <div className="Exp-sum-lbl">
                <label>Tax</label>
                <label>{fmtView(iTotalTax)}</label>
              </div>
              <div className="Exp-sum-lbl">
                <label>Round Off</label>
                <label>{fmtView(iRountoff)}</label>
              </div>
              <div className="Exp-sum-foot">
                <label>Net Amount</label>
                <label>{strNetAmt}</label>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-4 ">
            <div className="sum-container">
              {EIListTax.length > 0 && (
                <div className="Exp-sum-lbl" style={{ fontWeight: 600 }}>
                  <label>Tax</label>
                  <label>Taxable Amt</label>
                  <label>Tax Amt</label>
                </div>
              )}
              {EIListTax.map((Tax, Index) => (
                <div className="Exp-sum-lbl" key={Index}>
                  <label>{Tax.taxDesc}</label>
                  <label>{fmtView(Tax.taxableAmt)}</label>
                  <label>{fmtView(Tax.taxAmt)}</label>
                </div>
              ))}
              <div className="Exp-sum-foot">
                <label>Tax Amount</label>
                <label>{fmtINR(iTotalTax)}</label>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-4 ">
            <div className="sum-container">
              <div className="row p-2">
                <div className="col-sm-6 col-md-6">
                  <label>Bill Discount Per</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    aria-label="Bill discount percentage"
                    className="form-control"
                    name="dBillDisPer"
                    value={dBillDisPer}
                    disabled={!hasItems}
                    tabIndex={ListTabOrder.txtBillDiscPer}
                    onKeyDown={(e) => KeyDown(e)}
                    onChange={(e) => {
                      setdBillDisPer(cleanDecimal(e.target.value));
                      setdBillDisAmt(0);
                    }}
                    onBlur={() => CalcBillDisc("Per")}
                    onClick={(e) => e.target.select()}
                  />
                </div>
                <div className="col-sm-6 col-md-6">
                  <label>Bill Discount Amt</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    aria-label="Bill discount amount"
                    className="form-control"
                    name="dBillDisAmt"
                    value={dBillDisAmt}
                    disabled={!hasItems}
                    tabIndex={ListTabOrder.txtBillDiscAmt}
                    onChange={(e) => {
                      setdBillDisAmt(cleanDecimal(e.target.value));
                      setdBillDisPer(0);
                    }}
                    onBlur={() => CalcBillDisc("Amt")}
                    onClick={(e) => e.target.select()}
                    onKeyDown={(e) => KeyDown(e)}
                  />
                </div>
              </div>
              <div className="Exp-sum-foot">
                <label>Bill Discount</label>
                <label>{fmtINR(dBillDisValue)}</label>
              </div>
            </div>
          </div>
        </div>

        {/* ACTION BAR */}
        <div
          className="btn-section mt-2"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 20,
            background: "#fff",
            borderTop: "1px solid #dfe3e8",
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          <span
            style={{ marginRight: "auto", fontWeight: 600, whiteSpace: "nowrap" }}
            title="Net Amount"
          >
            Net Amount : {strNetAmt}
          </span>
          <button
            type="button"
            className="btn-fabgreen"
            disabled={isSaveBtn || isBusy}
            onClick={TrySave}
            tabIndex={ListTabOrder.btnSave}
            onKeyDown={(e) => KeyDown(e)}
          >
            Save &nbsp; <i className="fas fa-save"></i>
          </button>
          <button
            type="button"
            className="btn-fabgreen"
            tabIndex={ListTabOrder.btnClear}
            onKeyDown={(e) => KeyDown(e)}
            onClick={() =>
              isDirty
                ? Ask_Question(
                    dispatch,
                    () => ClearClick(),
                    "Unsaved changes will be lost. Do You Want to Clear ?"
                  )
                : ClearClick()
            }
          >
            Clear &nbsp; <i className="fas fa-eraser"></i>
          </button>
          <button
            disabled={isViewBtn}
            type="button"
            className="btn-fabgreen"
            onClick={(e) => setisTransView(!isTransView)}
            tabIndex={ListTabOrder.btnView}
            onKeyDown={(e) => KeyDown(e)}
          >
            View &nbsp; <i className="fas fa-eye"></i>
          </button>
          <button
            type="button"
            disabled={isDeleteBtn || iEIId === 0 || isBusy}
            title={iEIId === 0 ? "Open a saved voucher to delete it" : ""}
            className="btn-fabgreen"
            onClick={(e) => {
              Ask_Question(
                dispatch,
                () => fnRef.current.DeleteClick(),
                "Do You Want to Delete ?"
              );
            }}
            tabIndex={ListTabOrder.btnCancel}
            onKeyDown={(e) => KeyDown(e)}
          >
            Delete &nbsp; <i className="far fa-trash-alt"></i>
          </button>
          <button
            type="button"
            className="btn-fabgreen"
            tabIndex={ListTabOrder.btnClose}
            onKeyDown={(e) => KeyDown(e)}
            onClick={CloseClick}
          >
            Close &nbsp; <i className="fas fa-times"></i>
          </button>
        </div>
        {isNewParty && (
          <PartyCreation
            Close={(e) => setisNewParty(false)}
            strScrType="ServiceVendore"
          />
        )}
        {isService && (
          <ServicePicker
            onClose={() => setisService(false)}
            onSelect={(info) => Select_Service(info)}
          />
        )}
        {isTransView && (
          <CustomTransView
            Close={(e) => setisTransView(!isTransView)}
            ScrId={iScrId}
            Title="Expense Income"
            View_Invoice={ViewClick}
          />
        )}
        <Messagedialogbox />
      </div>
    </>
  );
}
export default ExpenseIncome;